import React, { useCallback } from 'react';
import { ObjectService, ServiceFieldType } from '../../types/ObjectTypes';
import { Td, Text, Tr } from '@chakra-ui/react';
import { Stepper, StepperOperator } from '../common/Stepper/Stepper';
import { getStringByServiceFieldType } from '../../services/Object/ObjectService';
import { FormikProps } from 'formik/dist/types';
import { BookingParams } from '../../types/BookingTypes';

export interface BookingServiceFormProps {
  objectService: ObjectService;
  formik: FormikProps<BookingParams & { [key: string]: any }>;
  name: string;
  idx: string | number;
  numberOfDays?: number;
}

export const BookingServiceForm = (props: BookingServiceFormProps): JSX.Element => {
  const { objectService, formik, name, idx, numberOfDays } = props;
  const formattedPrice = new Intl.NumberFormat('de-De', {
    style: 'currency',
    currency: 'EUR',
  }).format(objectService.Price);

  const handleChange = useCallback(
    (name: string, value: number, type: StepperOperator) => {
      if (type === StepperOperator.DECREMENT) {
        formik.setFieldValue(name, value - 1);
      }
      if (type === StepperOperator.INCREMENT) {
        formik.setFieldValue(name, value + 1);
      }
    },
    [idx, formik.values],
  );

  return (
    <>
      {objectService && (
        <Tr h={16}>
          <Td p={0} pr={4} lineHeight={1.2}>
            <Text>{objectService.Title}</Text>
            <Text fontSize={'xs'}>{objectService.Description}</Text>
            <Text fontSize={'xs'} color={'gray.400'}>
              {getStringByServiceFieldType(objectService.FieldType)}
            </Text>
          </Td>
          <Td p={0} pr={4}>
            <Stepper
              minimumValue={0}
              maximumValue={objectService.maximumNumber ? objectService.maximumNumber : undefined}
              handleChange={handleChange}
              name={`${name}[${idx}].quantity`}
              value={formik.values[name][idx].quantity}
              boxSize={8}
            />
          </Td>
          <Td
            p={0}
            pr={objectService.FieldType === ServiceFieldType.PER_DAY ? 0 : 4}
            isNumeric={true}>
            {objectService.FieldType === ServiceFieldType.PER_DAY && (
              <Stepper
                minimumValue={0}
                maximumValue={numberOfDays}
                handleChange={handleChange}
                name={`${name}[${idx}].numberOfDays`}
                value={formik.values[name][idx].numberOfDays}
                boxSize={8}
              />
            )}
            {objectService.FieldType !== ServiceFieldType.PER_DAY && numberOfDays
              ? numberOfDays
              : ''}
          </Td>
          <Td p={0} isNumeric={true}>
            <Text textAlign={'right'} w={'100%'}>
              {formattedPrice}
            </Text>
          </Td>
        </Tr>
      )}
    </>
  );
};
